import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import SummaryApi from "../common/SummaryApi";
import axios from "axios";
import { removeFromLocalWishlist } from "../helpers/wishlistHelper";
import Breadcrumb from "../components/BreadCrumb";

const WishlistSkeleton = () => {
  return (
    <div className="space-y-4">
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className="animate-pulse bg-[#F3F6FF] border border-[#B5CAFF] rounded-lg p-4 flex gap-4"
        >
          {/* Image */}
          <div className="w-20 h-20 bg-[#DCE4FF] rounded-lg" />

          {/* Content */}
          <div className="flex-1 space-y-2">
            <div className="h-3 w-24 bg-[#DCE4FF] rounded" />
            <div className="h-4 w-3/4 bg-[#DCE4FF] rounded" />
            <div className="h-3 w-32 bg-[#DCE4FF] rounded" />

            <div className="flex gap-2 mt-3">
              <div className="h-5 w-20 bg-[#DCE4FF] rounded" />
              <div className="h-4 w-14 bg-[#DCE4FF] rounded" />
              <div className="h-4 w-16 bg-[#DCE4FF] rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const EmptyWishlist = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
{/* <svg
  width="260"
  height="200"
  viewBox="0 0 260 200"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="130" cy="100" r="90" fill="#F3F6FF"/>

  <path
    d="M130 145s-35-22-50-44c-10-15-2-36 18-40 14-3 26 5 32 14 6-9 18-17 32-14 20 4 28 25 18 40-15 22-50 44-50 44z"
    fill="#B5CAFF"
  />

  <path
    d="M130 139s-31-20-45-40c-8-12-2-29 15-33 12-3 23 5 30 16 7-11 18-19 30-16 17 4 23 21 15 33-14 20-45 40-45 40z"
    stroke="#4F73FF"
    stroke-width="3"
    fill="none"
  />

  <circle cx="80" cy="60" r="4" fill="#EFD33D"/>
  <circle cx="185" cy="55" r="3" fill="#EFD33D"/>
  <circle cx="200" cy="120" r="4" fill="#B5CAFF"/>
  <circle cx="65" cy="125" r="3" fill="#B5CAFF"/>
</svg> */}

      <svg
        width="280"
        height="220"
        viewBox="0 0 280 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="20" y="20" width="240" height="180" rx="24" fill="#F3F6FF"/>

        <rect x="85" y="80" width="110" height="90" rx="12" fill="#FFFFFF" stroke="#4F73FF" stroke-width="2"/>
        <path
          d="M110 80C110 62 125 50 140 50C155 50 170 62 170 80"
          stroke="#4F73FF"
          stroke-width="2"
          fill="none"
        />

        <path
          d="M140 145s-18-11-26-22c-5-8-1-18 9-20 7-1 13 3 17 9 4-6 10-10 17-9 10 2 14 12 9 20-8 11-26 22-26 22z"
          fill="#FC92A8"
        />

        <path
          d="M65 70s-6-4-9-8c-2-3 0-7 4-8 3-1 6 1 7 4 1-3 4-5 7-4 4 1 6 5 4 8-3 4-9 8-9 8z"
          fill="#FFD1DC"
        />

        <path
          d="M215 55s-5-3-7-6c-2-2 0-6 3-7 3-1 5 1 6 3 1-2 3-4 6-3 3 1 5 5 3 7-2 3-7 6-7 6z"
          fill="#FFD1DC"
        />

        <circle cx="60" cy="150" r="4" fill="#B5CAFF"/>
        <circle cx="215" cy="160" r="3" fill="#B5CAFF"/>
        <circle cx="190" cy="40" r="4" fill="#EFD33D"/>
      </svg>

      <h3 className="text-lg font-semibold text-[#191C1F]">
        Your wishlist is empty
      </h3>
      <p className="text-sm text-[#676767] mt-1">
        Add products you love to see them here
      </p>
    </div>
  );
};


const Wishlist = () => {
  const [wishlist, setWishlist] = useState([]);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWishlist = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios({
          url: SummaryApi.getWishlist.url,
          method: SummaryApi.getWishlist.method,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setWishlist(res.data.wishlist || []);
      } finally {
        setLoading(false);
      }
    };

    fetchWishlist();
  }, [token]);

  const removeWishlistItem = async (productId) => {
    if (!token) {
      removeFromLocalWishlist(productId);
      setWishlist(prev => prev.filter(p => p.productId?._id !== productId));
      return;
    }

    await axios({
      url: SummaryApi.toggleWishlist.url,
      method: "post",
      data: { productId },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setWishlist(prev => prev.filter(p => p.productId?._id !== productId));
  };


  return (
    <div className="w-full space-y-6">
      {/* PAGE TITLE */}
        {/* HEADER */}
        <div>
          <h1 className="hidden lg:block text-xl font-bold mb-2">Wishlist</h1>

          <Breadcrumb
            items={[
              { label: "Home", path: "/" },
              { label: "My Account", path: "/my-account/menu" },
              { label: "Wishlist" }
            ]}
          />
        </div>

      {/* LIST */}
      <div className="space-y-4">
        {loading && <WishlistSkeleton />}

        {!loading && wishlist.length === 0 && <EmptyWishlist />}
        
      {!loading &&
       wishlist.length > 0 &&
        wishlist.map((item) => {
          if (!item.productId) return null;
          const product = item.productId;

          return (
            <div
              key={item._id}
              className="relative bg-[#F3F6FF] border border-[#B5CAFF] rounded-lg p-4 flex flex-col sm:flex-row gap-4"
            >
              {/* REMOVE */}
              <button
                onClick={() => removeWishlistItem(product._id)}
                className="absolute top-3 right-3 text-xs text-[#FC0924]"
              >
                Remove
              </button>

              {/* IMAGE (placeholder for now) */}
              <div className="flex-shrink-0">
                <img
                  src={product.previewImage || "/placeholder.png"}
                  alt={product.productName}
                  className="w-20 h-20 object-cover rounded-lg border-2 border-[#007BFF]"
                />
              </div>

              {/* CONTENT */}
              <div className="flex flex-col justify-between w-full">
                <div className="space-y-1">
                  <p className="text-sm font-medium text-[#191C1F]">
                    {product.brand}
                  </p>

                  <p className="text-sm text-[#191C1F] leading-snug">
                    {product.productName}
                  </p>

                  {/* RATING (STATIC FOR NOW) */}
                  <div className="flex items-center gap-1 text-sm">
                    <div className="flex items-center gap-0.5 text-[#FA8232]">
                      {[1, 2, 3, 4, 5].map((i) => (
                        <Star
                          key={i}
                          size={12}
                        className={
                          i <= Math.round(product.rating?.avg)
                            ? "text-[#FA8232] fill-[#FA8232]"
                            : "text-gray-300"
                        }
                        />
                      ))}
                    </div>
                    <span className="text-[#191C1F] text-xs font-semibold">
                      {product.rating?.count}
                    </span>
                  </div>
                </div>

                {/* PRICE (only if available later) */}
                <div className="flex items-center gap-2 mt-2 flex-wrap">
                  <span className="text-lg font-bold">₹{product.price}</span>
                  <span className="text-sm line-through text-[#676767]">
                    ₹{product.mrp}
                  </span>
                  <span className="text-xs font-regualr text-[#191C1F] bg-[#EFD33D] px-2 py-0.5 rounded-sm">
                    {product.discount}% OFF
                  </span>
                </div>
              </div>
            </div>
          );
        })}

      </div>
    </div>
  );
};

export default Wishlist;
